export const AUTH_URL = window.location.hostname.includes(
  'intelligentpackaging'
)
  ? 'https://passport.intelligentpackaging.online'
  : process.env.REACT_APP_AUTH_URL;
export const CABINET_API_URL = window.location.hostname.includes(
  'intelligentpackaging'
)
  ? 'https://cabinet-api.intelligentpackaging.online/api'
  : process.env.REACT_APP_CABINET_API_URL;

export const DEFAULT_IMAGE =
  process.env.REACT_APP_NO_PRODUCT_IMAGE_PLACEHOLDER ||
  'https://cdn.selflystore.com/cabinet-products/no-image.png';

export const APP_INSIGHTS_INSTRUMENTATION_KEY =
  process.env.REACT_APP_APPLICATION_INSIGHT_INSTRUMENTATION_KEY;
